import { GetStaticProps } from 'next'

import { DynamicPage } from '@/cmsComponents/DynamicPage'
import { DynamicPageProps } from '@/cmsComponents/DynamicPage'
import DefaultLayout from '@/layouts'
import { GetDataByCMS } from '@/services/CMSApi'
import Head from 'next/head'
import { GlobalConfig } from '@/types/cms'
import { TonPlansProviderProps } from '@/contexts/plans'
import { TonMachinesProviderProps } from '@/contexts/machines'
import { ModalPlanDetails } from '@/cmsComponents/ModalPlanDetails'
import { getGlobalData } from '@/utils/getGlobalData'

type ProvidersProps = Omit<TonPlansProviderProps, 'children'> &
  Omit<TonMachinesProviderProps, 'children'>

export interface DynamicPageGetStaticProps extends ProvidersProps {
  cmsPageData: DynamicPageProps
  globalConfig: GlobalConfig
}

export const getStaticProps: GetStaticProps<
  DynamicPageGetStaticProps
> = async () => {
  const cmsPageData = await GetDataByCMS('index')

  const {
    globalConfig,
    plansDetailsFromCMS,
    plansDetailsFromAPI,
    machinesDetailsFromAPI,
    machinesDetailsFromCMS
  } = (await getGlobalData()) || {}

  return {
    props: {
      cmsPageData,
      globalConfig,
      plansDetailsFromCMS,
      plansDetailsFromAPI,
      machinesDetailsFromAPI,
      machinesDetailsFromCMS
    }
  }
}

export default function Page({
  cmsPageData,
  globalConfig,
  plansDetailsFromCMS,
  plansDetailsFromAPI,
  machinesDetailsFromAPI,
  machinesDetailsFromCMS
}: DynamicPageGetStaticProps) {
  return (
    <>
      <Head>
        <link
          rel="preload"
          href="/sprites/index.svg"
          as="image"
          type="image/svg+xml"
        />
      </Head>

      <DefaultLayout
        defaultPlan={cmsPageData.defaultPlan}
        plansDetailsFromCMS={plansDetailsFromCMS}
        plansDetailsFromAPI={plansDetailsFromAPI}
        machinesDetailsFromAPI={machinesDetailsFromAPI}
        machinesDetailsFromCMS={machinesDetailsFromCMS}
      >
        <DynamicPage {...cmsPageData} globalConfig={globalConfig} />

        <ModalPlanDetails />
      </DefaultLayout>
    </>
  )
}
